var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2712_4968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1618 12.7166C16.1618 10.9497 15.163 9.94389 13.3839 9.91347C13.2562 7.41435 11.715 6.01611 9.06398 6.01611C6.88889 6.01611 5.46094 6.95738 4.94775 8.67567C4.93264 8.67556 4.91748 8.6755 4.90229 8.6755C2.55982 8.6755 1.24219 9.96658 1.24219 12.2618C1.24219 16.5829 7.04995 16.7583 9.06398 16.7583C11.078 16.7583 16.1618 16.6179 16.1618 12.7166Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86719 8.67725C6.21869 8.67725 7.42741 9.55013 7.8087 10.3476",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3691 3.46314C10.526 3.00273 10.788 2.57023 11.1551 2.20307C11.8434 1.51481 12.7612 1.1961 13.6621 1.24694C13.3813 2.09651 13.5788 3.06959 14.2546 3.74545C14.9305 4.42133 15.9035 4.61881 16.7531 4.33795C16.804 5.23885 16.4853 6.15672 15.7971 6.84497C15.6999 6.94207 15.5982 7.0318 15.4927 7.11419",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2712_4968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.e6f5cb937d2cee4ba20529be7c6918c2.svg";
export { ForwardRef as ReactComponent };